"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BytesUtilsMock__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "offset",
                type: "uint256",
            },
        ],
        name: "extractBytes32",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "extractBytes32Result",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class BytesUtilsMock__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BytesUtilsMock__factory = BytesUtilsMock__factory;
BytesUtilsMock__factory.bytecode = _bytecode;
BytesUtilsMock__factory.abi = _abi;
